module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12\">\r\n            <h1>")
    ; __append(escapeFn(dashboardTitle))
    ; __append("</h1>\r\n        </div>\r\n    </div>\r\n\r\n    <ol class=\"breadcrumb\">\r\n        ")
    ; 
        var count = breadcrumbs.length;
        var crumbCount = 0;
        _.forEach(breadcrumbs, function (crumb) {
            crumbCount++;
            if (crumbCount === count) {
            
    ; __append("\r\n            <li>")
    ; __append(escapeFn(crumb.name))
    ; __append("</li>\r\n            ")
    ;       } else { 
    ; __append("\r\n            <li><a href=\"")
    ; __append(escapeFn(crumb.route))
    ; __append("\" id=\"")
    ; __append(escapeFn(crumb.id))
    ; __append("\">")
    ; __append(escapeFn(crumb.name))
    ; __append("</a></li>\r\n            ")
    ; 
            }
        });
    ; __append("\r\n    </ol>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-sm-12 col-lg-6\">\r\n        <div class=\"block\">\r\n            <h2>General</h2>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                    <span>Name</span>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <span>")
    ; __append(escapeFn( name ))
    ; __append("</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                    <span>App Name</span>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <span>")
    ; __append(escapeFn( formName ))
    ; __append("</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                    <span>App Version</span>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <span>")
    ; __append(escapeFn( version ))
    ; __append("</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                    <span>First Submission</span>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <span>")
    ; __append(escapeFn( firstSubmissionDate ))
    ; __append("</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                    <span>Last Submission</span>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <span>")
    ; __append(escapeFn( lastSubmissionDate ))
    ; __append("</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                    <span>Stage</span>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <span>")
    ; __append(escapeFn( stage ))
    ; __append("</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                    <span>Status</span>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <span>")
    ; __append(escapeFn( status ))
    ; __append("</span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"col col-sm-12 col-lg-6\">\r\n        <div class=\"block\">\r\n            <h2>Attention Levels</h2>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                    <span>Mine</span>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <span>")
    ; __append(escapeFn( myAttentionLevel ))
    ; __append("</span>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-6\">\r\n                    <span>Anyone else</span>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                    <span>")
    ; __append(escapeFn( otherAttentionLevel ))
    ; __append("</span>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"notification-section\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <h2>Notifications</h2>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <table id=\"propMainTable\"></table>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div id=\"footer-details\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-2\">\r\n            <button id=\"viewInstance\" disabled class=\"btn btn-default\">View</button>\r\n        </div>\r\n        <div class=\"col-md-2\">\r\n            <button id=\"viewData\" class=\"btn btn-default\">Data History</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}